module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av248-63515e5b1da5e33ecbc8d97e59521a8e.jpg";